var $4e4f59529c29e701$exports = {};
$4e4f59529c29e701$exports = {
    "collectionLabel": `Pasi\u{16B}lymai`
};


export {$4e4f59529c29e701$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
